// src/config/tenant.js
//
// HARDCODED TENANT CONFIG — Phase 1
// This storefront currently serves ONE tenant + ONE branch.
// Change these two values and rebuild to point the shop at a
// different tenant. No tenant-picker UI, no login-based resolution.
//
// FUTURE: once customers log in with accounts that carry their own
// tenant_id, delete this file and resolve tenant/branch dynamically
// instead (subdomain, login flow, etc). The only other file that
// references these constants is src/services/api.js.


export const TENANT_ID = 7;
export const BRANCH_ID = 10;
export const TENANT_NAME  = 'Factoryoutlet Crackers';
export const SHOP_NAME    = 'Factoryoutlet Crackers';
export const SHOP_TAGLINE = 'SIVAKASI DIRECT';

// Admin's WhatsApp number (with country code, no +/spaces/dashes).
// Used for: the floating WhatsApp chat button, the Contact page, and
// the checkout order notification (CheckoutPage.jsx sends the full
// order + customer details here instead of taking online payment).
export const ADMIN_WHATSAPP_NUMBER = '917339260360';

// Admin's own email inbox — the checkout page opens a prefilled email
// (mailto:) addressed to this address as a second notification channel
// alongside WhatsApp. See the big comment in CheckoutPage.jsx for why
// the "From" can't be pinned to a specific address from a static
// frontend — mailto: always sends from whichever account is already
// signed into the customer's own mail app, never a fixed sender.
export const ADMIN_EMAIL = 'factoryoutletcracker@gmail.com';

// Reused on the invoice PDF header, the Contact page, and the footer.


export const SHOP_ADDRESS_LINES = [
  'Factory Outlet Crackers,',
  'Sivakasi.',
];
export const SHOP_ADDRESS = SHOP_ADDRESS_LINES.join(' ');

export const SHOP_PHONES  = ['+91 73392 60360'];

// Minimum order value (₹) — shown on the Products page, Home page and Terms page.
export const MIN_ORDER_TN     = 3500;   // Tamil Nadu
export const MIN_ORDER_OTHER  = 6500;   // Other states



// src/config/tenant.js
//
// HARDCODED TENANT CONFIG — Phase 1
// This storefront currently serves ONE tenant + ONE branch.
// Change these two values and rebuild to point the shop at a
// different tenant. No tenant-picker UI, no login-based resolution.
//
// FUTURE: once customers log in with accounts that carry their own
// tenant_id, delete this file and resolve tenant/branch dynamically
// instead (subdomain, login flow, etc). The only other file that
// references these constants is src/services/api.js.




// ── Business identity ─────────────────────────────────────────────
// Single source of truth for the shop's name and contact details.
// Header, Footer, Contact page, checkout message, invoice PDF and the
// WhatsApp button all read from here — edit only this block.


// Admin's WhatsApp number (with country code, no +/spaces/dashes).
// Used for: the floating WhatsApp chat button, the Contact page, and
// the checkout order notification (CheckoutPage.jsx sends the full
// order + customer details here instead of taking online payment).

// Address — lines are used where a multi-line layout fits (footer,
// contact page, invoice); SHOP_ADDRESS is the one-line form.
// Offer % shown on the Home hero, Products banner and category headers.
// Set to null to use the discount configured in admin instead.
// NOTE: actual product prices still come from admin — set the admin
// offer to the same % so the prices match what the banner says.
export const OFFER_PERCENT = 90;

// Packing / delivery charge — fallback only.
// The live values come from the tenant row in the database
// (tenants.packing_charge_pct / packing_charge_label, migration 012) via
// GET /api/v1/shop/settings. These are used only if that call isn't
// available yet. 0 = off (nothing shown anywhere).
export const PACKING_CHARGE_PCT   = 0;
export const PACKING_CHARGE_LABEL = 'Packing Charges';
